import { action } from 'easy-peasy';
import { IActionSetClinic } from '../types';

const setClinic: IActionSetClinic = action((state, clinic) => {
  state.current = clinic;
});

export default setClinic;
